import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface IdentRutaPayload {
  nombre_ruta: string;
  salida: string;
  destino: string;
  kilometros_recorridos: number;
  tipo_ruta: number;
  frecuencia_recorrido: number;
  usos_ruta: number;
  estado?: number;
}

@Injectable({
  providedIn: "root",
})
export class IdentRutasService {
  private apiUrl = `${environment.apiUrl}/api/ident_rutas`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl, { withCredentials: true });
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  create(payload: IdentRutaPayload): Observable<any> {
    return this.http.post<any>(this.apiUrl, payload, { withCredentials: true });
  }

  update(id: number, payload: Partial<IdentRutaPayload>): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }
}
